import {
  GolfListType,
  PMSReqGolfReceiptNewDetail,
  PMSResGolfDateCoseItem,
  PMSResGolfDateCoseList,
  PMSResGolfDateTeeListItem,
  PMSResGolfDateTeeTimeItem,
} from '@/models-golf';
import moment from 'moment';
import {DateUtil} from '@/util/DateUtil';

/***
 * 사전 접수 API MODEL
 */
export class ReceiptRent {
  upjangCode: string;
  menuCode: string;
  saleQty: number;
  salePrice: number;

  constructor(upjangCode: string, menuCode: string, saleQty: number, salePrice: number) {
    this.upjangCode = upjangCode;
    this.menuCode = menuCode;
    this.saleQty = saleQty;
    this.salePrice = salePrice;
  }
}

/***
 * 사전 접수 API MODEL
 */
export class ReceiptModel {
  bookDate: string;
  coseCd: string;
  holeCd: string;
  reqTimeCd!: string;
  teamManCnt: number;
  teamWomanCnt: number;
  memNo: string;
  hpNo: string; //예약자 연락처
  bookName: string;
  smsSendYn: string;
  gscName: string;
  gscHpNo: string;
  gscSmsSendYn: string;
  recommYn: string;
  regName: string;
  regHpNo: string;
  regSmsSendYn: string;
  remarks: string;
  rentList: ReceiptRent[];

  gscGuestNo: string;

  constructor(viewModel: ReceiptViewModel) {
    this.bookDate = DateUtil.getYYYYMMDD(viewModel.selectedDate);
    this.coseCd = viewModel.selectedCourse!.coseCd;
    this.holeCd = '002';
    this.reqTimeCd = viewModel.selectedTeeOff!.detail;
    this.hpNo = viewModel.receiptDetail!.hpNo;
    this.teamManCnt = viewModel.receiptDetail!.teamManCnt;
    this.teamWomanCnt = viewModel.receiptDetail!.teamWomanCnt;

    this.memNo = viewModel.receiptDetail!.memNo;
    this.bookName = viewModel.receiptDetail!.bookName;
    this.smsSendYn = viewModel.receiptDetail!.smsSendYn;
    this.gscName = viewModel.receiptDetail!.gscName;
    this.gscHpNo = viewModel.receiptDetail!.gscHpNo;
    // 이용자 이름이 비어있으면 예약 안됨 (골프 회원의 경우)
    if (!this.gscName) this.gscName = this.bookName;
    if (!this.gscHpNo) this.gscHpNo = this.hpNo;

    this.gscSmsSendYn = viewModel.receiptDetail!.gscSmsSendYn;
    this.recommYn = viewModel.receiptDetail.recommYn;
    this.regName = viewModel.receiptDetail.regName;
    this.regHpNo = viewModel.receiptDetail.regHpNo;
    this.regSmsSendYn = viewModel.receiptDetail.regSmsSendYn;
    this.remarks = viewModel.receiptDetail.remarks;

    // recommYn
    this.recommYn = viewModel.receiptDetail._bookedBy === 'SelfBook' ? 'N' : 'Y';

    this.rentList = [];

    viewModel.receiptDetail._rentListClub.forEach(x => {
      const vm = viewModel.receiptDetail.rentList[x._idx];
      const data = new ReceiptRent(vm.upjangCode, vm.menuCode, x.saleQty, vm.salePrice);
      this.rentList.push(data);
    });

    viewModel.receiptDetail._rentListShoes.forEach(x => {
      const vm = viewModel.receiptDetail.rentList[x._idx];
      const data = new ReceiptRent(vm.upjangCode, vm.menuCode, x.saleQty, vm.salePrice);
      this.rentList.push(data);
    });

    viewModel.receiptDetail._rentListCarts.forEach(x => {
      const vm = viewModel.receiptDetail.rentList[x._idx];
      const data = new ReceiptRent(vm.upjangCode, vm.menuCode, x.saleQty, vm.salePrice);
      this.rentList.push(data);
    });

    this.gscGuestNo = viewModel.receiptDetail.gscGuestNo;
  }
}

export class ReceiptRealModel {
  reservArr: string;
  memNo: string;
  smsSendYn: string;
  gscName: string;
  gscHpNo: string;
  gscSmsSendYn: string;
  recommYn: string;
  regName: string;
  regHpNo: string;
  regSmsSendYn: string;
  teamManCnt: number;
  teamWomanCnt: number;
  cardNo: string;
  cardYymm: string;
  cardIssueCode: string;
  remarks: string;
  rentList: ReceiptRent[];
  gscGuestNo: string;

  constructor(vm: ReceiptViewModel) {
    this.reservArr = `1|${moment(vm.selectedDate).format('YYYYMMDD')}|${vm.selectedCourse!.coseCd}|${
      vm.selectedRealTeeOff!.time
    }`;
    this.teamManCnt! = vm.receiptDetail!.teamManCnt;
    this.teamWomanCnt! = vm.receiptDetail!.teamWomanCnt;

    this.memNo! = vm.receiptDetail!.memNo;
    this.smsSendYn! = vm.receiptDetail!.smsSendYn;
    this.gscName! = vm.receiptDetail!.gscName;
    this.gscHpNo! = vm.receiptDetail!.gscHpNo;
    this.gscSmsSendYn! = vm.receiptDetail!.gscSmsSendYn;

    this.regName = vm.receiptDetail.regName;
    this.regHpNo = vm.receiptDetail.regHpNo;
    this.regSmsSendYn = vm.receiptDetail.regSmsSendYn;
    this.remarks = vm.receiptDetail.remarks;

    // recommYn
    this.recommYn! = vm.receiptDetail!._bookedBy === 'SelfBook' ? 'N' : 'Y';

    // 현재 사용하지 않는 필드(카드)
    this.cardNo = '';
    this.cardYymm = '';
    this.cardIssueCode = '';

    this.rentList = [];

    vm.receiptDetail._rentListClub.forEach(x => {
      const rentVm = vm.receiptDetail.rentList[x._idx];
      const data = new ReceiptRent(rentVm.upjangCode, rentVm.menuCode, x.saleQty, rentVm.salePrice);
      this.rentList.push(data);
    });

    vm.receiptDetail._rentListShoes.forEach(x => {
      const rentVm = vm.receiptDetail.rentList[x._idx];
      const data = new ReceiptRent(rentVm.upjangCode, rentVm.menuCode, x.saleQty, rentVm.salePrice);
      this.rentList.push(data);
    });

    this.gscGuestNo! = vm.receiptDetail!.gscGuestNo;
  }
}

// 예약 ViewModel
export class ReceiptViewModel {
  // STAGE1
  selectedDate: Date | null;
  selectedCourse: PMSResGolfDateCoseItem | null;
  selectedTeeOff: PMSResGolfDateTeeTimeItem | null;
  selectedRealTeeOff: PMSResGolfDateTeeListItem | null;
  teamIndex: number;
  teamCount: number;
  teamLimitCount: number;
  teamReservCount: number;

  // STAGE 2
  public receiptDetail: PMSReqGolfReceiptNewDetail;

  constructor() {
    this.selectedDate = null;
    this.selectedCourse = null;
    this.selectedTeeOff = null;
    this.selectedRealTeeOff = null;
    this.teamIndex = 1;
    this.teamCount = 0;
    this.teamLimitCount = 0;
    this.teamReservCount = 0;
    this.receiptDetail = new PMSReqGolfReceiptNewDetail();
  }

  public Compare(item: ReceiptViewModel) {
    const flag2 = DateUtil.getYYYYMMDD(this.selectedDate) === DateUtil.getYYYYMMDD(item.selectedDate);
    const flag3 = this.selectedCourse!.coseCd === item.selectedCourse!.coseCd;
    const flag4 = this.selectedCourse!.coseItem === item.selectedCourse!.coseItem;
    const flag5 = this.selectedCourse!.coseName === item.selectedCourse!.coseName;

    if (this.selectedTeeOff) {
      // 사전/대기접수 모델
      const flag6 = this.selectedTeeOff!.detail === item.selectedTeeOff!.detail;
      const flag7 = this.selectedTeeOff!.detailName === item.selectedTeeOff!.detailName;

      return flag2 && flag3 && flag4 && flag5 && flag6 && flag7;
    } else {
      // 실시간 모델
      // time: string; //티오프시간
      // rndCd: string; //홀코드
      // rndCode: string; //홀명칭
      const flag6 = this.selectedRealTeeOff!.time === item.selectedRealTeeOff!.time;
      const flag7 = this.selectedRealTeeOff!.rndCd === item.selectedRealTeeOff!.rndCd;
      const flag8 = this.selectedRealTeeOff!.rndCode === item.selectedRealTeeOff!.rndCode;

      return flag2 && flag3 && flag4 && flag5 && flag6 && flag7 && flag8;
    }
  }

  public CompareWithDate(selectedDate: Date) {
    const flag2 = DateUtil.getYYYYMMDD(this.selectedDate) === DateUtil.getYYYYMMDD(selectedDate);
    return flag2;
  }

  public CompareWithDateAndCourse(selectedDate: Date, selectedCourse: PMSResGolfDateCoseItem) {
    const flag2 = DateUtil.getYYYYMMDD(this.selectedDate) === DateUtil.getYYYYMMDD(selectedDate);
    const flag3 = this.selectedCourse!.coseCd === selectedCourse!.coseCd;
    const flag4 = this.selectedCourse!.coseItem === selectedCourse!.coseItem;
    const flag5 = this.selectedCourse!.coseName === selectedCourse!.coseName;
    return flag2 && flag3 && flag4 && flag5;
  }

  public SetReceiptDetail(s: PMSReqGolfReceiptNewDetail) {
    //이용자
    this.receiptDetail!.gscName = s!.gscName;
    this.receiptDetail!.gscHpNo = s!.gscHpNo;
    this.receiptDetail!.gscSmsSendYn = s!.gscSmsSendYn;

    //예약자
    this.receiptDetail!.bookName = s!.bookName;
    this.receiptDetail!.hpNo = s!.hpNo;
    this.receiptDetail!.smsSendYn = s!.smsSendYn;
    //예약자와 동일
    this.receiptDetail._receiptDetail_RealUserSame = s._receiptDetail_RealUserSame;

    //신청자
    this.receiptDetail!.regName = s!.regName;
    this.receiptDetail!.regHpNo = s!.regHpNo;
    this.receiptDetail!.regSmsSendYn = s!.regSmsSendYn;

    //인원수
    this.receiptDetail!.teamManCnt = s!.teamManCnt;
    this.receiptDetail!.teamWomanCnt = s!.teamWomanCnt;

    //추천인접수 여부
    this.receiptDetail!._bookedBy = s!._bookedBy;

    //본인/배우자접수의 이용자 선택
    this.receiptDetail!._selected_RealUserSelfOrFamily = {...s!._selected_RealUserSelfOrFamily};
    this.receiptDetail!._gscHpNoBlank = s!._gscHpNoBlank;

    //이용자 고객번호 입력
    this.receiptDetail!.gscGuestNo = s!.gscGuestNo;
  }

  public toApiReceiptModel() {
    const result: ReceiptModel[] = [];
    for (let i = 0; i < this.teamCount; i++) {
      result.push(new ReceiptModel(this));
    }
    return result;
  }

  public toApiRealModel() {
    const result: ReceiptRealModel[] = [];
    for (let i = 0; i < this.teamCount; i++) {
      result.push(new ReceiptRealModel(this));
    }
    return result;
  }
}
